import { OrderHistoryRecord } from "@core/models/order-history-record";

export class OrderHistoryRecordViewModel {
	readonly orderLineId: string;
	readonly oldValue: string;
	readonly newValue: string;
	readonly historySubtypeKey: string;

	constructor (orderHistoryRecord: OrderHistoryRecord) {
		this.orderLineId = orderHistoryRecord.orderlineId?.toString() || "";
		this.oldValue = orderHistoryRecord.oldValue?.toLocaleString() || undefined;
		this.newValue = orderHistoryRecord.newValue?.toLocaleString() || "";

		const historySubtype = (orderHistoryRecord.historySubtype || "MISSING").toUpperCase();

		this.historySubtypeKey = `ORDER_LINE.HISTORY.${historySubtype}`;
	}
}
